import { render } from "./HidePaginWhenThereIsOnePg.vue?vue&type=template&id=5aad68e7"
import script from "./HidePaginWhenThereIsOnePg.vue?vue&type=script&lang=js"
export * from "./HidePaginWhenThereIsOnePg.vue?vue&type=script&lang=js"
script.render = render

export default script